module.exports = __webpack_public_path__ + "img/img4.87c54123.svg";